export default __webpack_public_path__ + "static/avatar-kayi-special-0-detail-8ee5173705d984789d3b2b8aff2fb3db.png";